module.exports = __webpack_public_path__ + "static/media/portfolio.bc18629b.png";